
import { downloadFileBlob } from '@/api/file'
// 全局的一些混入信息
export default {
  data () {
    return {
      // 头像-无文件流-缺省图
      defaultImg: '' // require('@/assets/images/webImg/avatar2.jpg')
    }
  },
  methods: {
    // 头像显示和预览
    async getAvatarImg (row) {
      if (row && row.fileCode && row.fileToken) {
        const param = {
          fileCode: row.fileCode,
          fileToken: row.fileToken
        }
        const url = await downloadFileBlob(param)
        // console.log(url)
        return url
      } else {
        return ''
      }
    },
    // 获取文件后缀/文件类型
    getFileExtension (fileName) {
      return fileName.split('.').pop()
    },
    // 文件流下载
    getPreviewFile (record) {
      // 文件名称及文件后缀获取
      const fileName = record.fileName
      const fileType = this.getFileExtension(record.fileName)

      const param = {
        fileCode: record.fileCode,
        fileToken: record.fileToken
      }
      downloadFileBlob(param).then(res => {
        const a = document.createElement('a')
        a.href = window.URL.createObjectURL(new Blob([res], { type: 'application/' + fileType + ';charset=utf8' }))
        a.download = fileName
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        a.remove()
      })
    }
  }
}
